import React, {useEffect, useState, ChangeEvent} from "react";
import {useExportExcelDownload, useReadContactList} from "../hooks";
import {SubmitHandler, useForm} from "react-hook-form";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import EmptyTableRow from "../../../common/EmptyTableRow";
import useSelectCheckbox from "../../../../hooks/useSelectCheckbox";
import useDeleteContact from "../hooks/useDeleteContact";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import {useSearchParams} from "react-router-dom";
import {useModal} from "../../../../hooks";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";
import Form from "react-bootstrap/Form";

type Props = {};

export const ContactList = (props: Props) => {
    const {handleModal} = useModal();
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const defaultSearchValue = {
        keywordType: "0",
        keyword: "",
        limit: 10,
        pageNo: "1",
        accountId: "",
        // 내부수정: 활성/비활성
        statusCodeList: ["N"],
    };

    const [searchOption, setSearchOption] = useState<
        AccountSearchInterface & { accountId: string }
    >(defaultSearchValue);

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchOption,
    });
    const {selectList, handleSelectCheckbox, isSelected, selectAll, clear} =
        useSelectCheckbox();
    const {goToNavigation} = useGoToNavigation();

    const {data} = useReadContactList({
        searchOption: searchOption,
    });

    const {mutate: downloadMutate} = useExportExcelDownload();
    const {mutate: deleteMutate} = useDeleteContact({clear});

    // 내부수정: 활성/비활성
    const onCheckHandler = (e: ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target;
        const value = name === "state-checkbox-1" ? 'N' : 'Y';
        const current = getValues("statusCodeList") ?? [];
        const flag = current.some((el: string) => el === value);
        const next = flag ? current.filter((el: string) => el !== value) : [...current, value];
        setValue("statusCodeList", next);
    }

    const onSubmit: SubmitHandler<
        AccountSearchInterface & { accountId: string }
    > = (submitData) => {
        setSearchOption(submitData);
        clear();
    };

    const dataList = data?.contactList ?? []
    const totalCount = data?.totalCount ?? 0

    useEffect(() => {
        setSearchOption({...searchOption, pageNo: page})
    }, [page]);

    // 내부수정: 새창으로 열리기
    const clickRow = (item: any, e: React.MouseEvent) => {
        if (!item?.contactId) return;
        const url = "customer/contact/detail/" + item.contactId;

        // 휠 클릭
        if (e.button === 1) {
            sessionStorage.setItem(`nav_state:${url}`, JSON.stringify(item)); // 내부수정: 새창용 state 저장
            goToNavigation(url, {}, false, { newTab: true });
            return;
        }
        // ctrl / cmd
        if (e.ctrlKey || e.metaKey) {
            sessionStorage.setItem(`nav_state:${url}`, JSON.stringify(item)); // 내부수정: 새창용 state 저장
            goToNavigation(url, {}, false, { newTab: true });
            return;
        }
        // 일반 클릭
        if (e.button === 0) {
            goToNavigation(url, item, false);
        }
    };

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">연락처 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <form className="row" onSubmit={handleSubmit(onSubmit)}>
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label className="form-label frm_label">상태</label>
                            <Form.Check
                                inline
                                label="활성"
                                type="checkbox"
                                id="state-checkbox-1"
                                name="state-checkbox-1"
                                checked={watch("statusCodeList")?.includes('N') ?? false}
                                onChange={onCheckHandler}
                            />
                            <Form.Check
                                inline
                                label="비활성"
                                type="checkbox"
                                id="state-checkbox-2"
                                name="state-checkbox-2"
                                checked={watch("statusCodeList")?.includes('Y') ?? false}
                                onChange={onCheckHandler}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">
                                검색어
                            </label>
                            <select className="form-select" {...register("keywordType")}>
                                <option value="0">전체</option>
                                <option value="1">이름</option>
                                <option value="2">회사명</option>
                                <option value="3">휴대폰</option>
                                <option value="4">회사 이메일</option>
                                <option value="5">담당자</option>
                            </select>
                            <input
                                type="text"
                                className="form-control"
                                {...register("keyword")}
                            />
                            <button className="btn btn-info btn_search">
                                <img
                                    src={
                                        process.env.PUBLIC_URL + "/assets/images/icon_search.png"
                                    }
                                    alt=""
                                />
                                조회
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        연락처 목록(<span>{totalCount ?? 0}</span>건)
                    </h6>
                    <div className="table_toolbar">
                        <button
                            className="btn btn-dark w-150px px-0"
                            onClick={() => {
                                downloadMutate(searchOption);
                            }}
                        >
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"}
                                alt=""
                            />
                            엑셀 내보내기
                        </button>
                        <AuthorityChecker authorityNames={['contactWriteYn']}>
                            <button
                                className="btn btn-primary w-100px px-0 ms-40px"
                                onClick={() => {
                                    goToNavigation("customer/contact/create", {}, false);
                                }}
                            >
                                연락처 생성
                            </button>
                            <button
                                className="btn btn-outline-dark w-100px px-0"
                                onClick={() => {
                                    if (selectList.length === 0) {
                                        handleModal({
                                            isOpen: true,
                                            contents: "삭제할 항목을 선택해주세요.",
                                            type: "alert"
                                        })

                                        return;
                                    }

                                    handleModal({
                                        isOpen: true,
                                        contents: "삭제하시겠습니까?",
                                        type: "confirm",
                                        callback: () => {
                                            const deleteList = dataList?.filter((item) => {
                                                if (selectList.includes(item?.contactId)) {
                                                    return item;
                                                }
                                            });

                                            if (deleteList && deleteList?.length > 0) {
                                                deleteMutate(
                                                    deleteList.map((item) => {
                                                        return {id: item?.contactId};
                                                    })
                                                );
                                            }
                                        }
                                    })
                                }}
                            >
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"}
                                    alt=""
                                />
                                선택삭제
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                {/* 내부수정: table_scroll 삭제 */}
                <table className="table table-bordered my_table">
                    <thead>
                    <tr>
                        <th style={{width: "3%"}}>
                            <div className="checkbox_outer">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    onClick={() => {
                                        if (data) {
                                            selectAll(
                                                dataList.map((item) => {
                                                    return {...item, _id: item.contactId};
                                                })
                                            );
                                        }
                                    }}
                                    checked={
                                        dataList && dataList?.length > 0
                                            ? dataList?.length <= selectList.length
                                            : false
                                    }
                                />
                            </div>
                        </th>
                        <th style={{width: "9%"}}>이름</th>
                        <th style={{width: "6%"}}>직함</th>
                        <th style={{width: "12%"}}>회사명</th>
                        <th style={{width: "8%"}}>부서</th>
                        <th style={{width: "8%"}}>팀</th>
                        {/* <th style={{width: "11%"}}>산업구분</th> */}
                        <th style={{width: "8%"}}>근무처 전화</th>
                        <th style={{width: "8%"}}>휴대폰</th>
                        <th style={{width: "15%"}}>회사 이메일</th>
                        {/*<th style={{width: "8%"}}>컨택 경로</th>*/}
                        <th style={{width: "5%"}}>담당자</th>
                        <th style={{width: "4%"}}>상태</th>
                    </tr>
                    </thead>
                    <tbody>
                    {dataList?.length === 0 ? (
                        <EmptyTableRow colSpan={12}/>
                    ) : (
                        dataList?.map((item) => (
                            <tr 
                                className={isSelected({_id: item?.contactId}) ? "lightblue clickable" : "clickable"}
                                /*
                                onClick={() => {
                                    goToNavigation(
                                        "customer/contact/detail/" + item?.contactId,
                                        item,
                                        false
                                    );
                                } */
                                // 내부수정: 새창으로 열리기
                                onMouseDown={(e) => clickRow(item, e)}
                            >
                                    
                                <td
                                    onClick={(e: React.MouseEvent<any>) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                e.stopPropagation();
                                                handleSelectCheckbox({
                                                    _id: item?.contactId,
                                                });
                                            }}
                                            checked={isSelected({_id: item?.contactId})}
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{item?.fullName}</td>
                                <td className="text-center">{item?.jobTitle}</td>
                                <td className="text-center">{item?.companyName}</td>
                                <td className="text-center">{item?.department}</td>
                                <td className="text-center">{item?.newTxtTeam}</td>
                                {/*<td className="text-center">{item?.industryCategory}</td>*/}
                                <td className="text-center">{item?.telephone1}</td>
                                <td className="text-center">{item?.mobilePhone}</td>
                                <td className="text-center">{item?.emailAddress1}</td>
                                {/*<td className="text-center">{item?.contactPath}</td>*/}
                                <td className="text-center">{item?.chargeName}</td>
                                <td className="text-center">{item?.stateCode}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
                

                <PaginationMain totalCount={totalCount}/>
            </div>
        </>
    );
};
